import { render, staticRenderFns } from "./BodyPreview.vue?vue&type=template&id=6cbafa98&scoped=true"
import script from "./BodyPreview.vue?vue&type=script&lang=js"
export * from "./BodyPreview.vue?vue&type=script&lang=js"
import style0 from "./BodyPreview.vue?vue&type=style&index=0&id=6cbafa98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbafa98",
  null
  
)

export default component.exports